import { render } from "./Linda_page4.vue?vue&type=template&id=2ae13276&scoped=true"
import script from "./Linda_page4.vue?vue&type=script&lang=js"
export * from "./Linda_page4.vue?vue&type=script&lang=js"

import "./Linda_page4.vue?vue&type=style&index=0&id=2ae13276&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2ae13276"]])

export default __exports__